import { createGraphqlHeader } from '../utils/functions/headers';
import { graphQLEmptySplitApi } from './emptySplitApi';

export const MasterCatalogueGraphQlService =
  graphQLEmptySplitApi
    .enhanceEndpoints({ addTagTypes: ['imageList'] })
    .injectEndpoints({
      endpoints: (builder) => ({
        getMasterCatalogueList: builder.query({
          query: (data) => ({
            url: '',
            method: 'POST',
            data: {
              query: `
            query executeCatalogProductFilterV2(
              $input: Input_farm_nurture_product_service_proto_CatalogProductFilterV2Request
            ) {
              executeCatalogProductFilterV2(input: $input) {
                status {
                  status
                  errorMessages
                  internalErrorCode
                }
                count
                attribs {
                  key
                  value
                }
                records {
                  status {
                    status
                    errorMessages
                    internalErrorCode
                  }
                  count
                  attribs {
                    key
                    value
                  }
                  records {
                    id
                    hsnCode
                    productName
                    status
                    measurementUnit
                    unitWeight
                    unitsCount
                    categoryName
                    centralTax
                    stateTax
                    integratedTax
                    categoryId
                    parentBrandName
                    parentBrandId
                    subBrand
                    gstApplicable
                    materialGroupCode
                    createdBy
                    createdDate
                    modifiedBy
                    modifiedDate
                  }
                }
              }
            }
          `,
              variables: { input: data },
            },
            headers: createGraphqlHeader(),
          }),
        }),
        getMasterCatalogueProductById: builder.query({
          query: (data) => ({
            url: '',
            method: 'POST',
            data: {
              query: `query executeReadCatalogProductById ($input: Input_farm_nurture_product_service_proto_ReadCatalogProductByIdRequest) {
              executeReadCatalogProductById (input: $input) {
                  status {
                    status
                    errorMessages
                    internalErrorCode
                  }
                  count
                  attribs {
                      key
                      value
                  }
                  records {
                    id
                    hsnCode
                    productName
                    status
                    measurementUnit
                    unitWeight
                    unitsCount
                    categoryName
                    centralTax
                    stateTax
                    integratedTax
                    categoryId
                    parentBrandName
                    parentBrandId
                    subBrand
                    gstApplicable
                    materialGroupCode
                    createdBy
                    createdDate
                    modifiedBy
                    modifiedDate
                  }
              }
          }`,
              variables: { input: data },
            },
            headers: createGraphqlHeader(),
          }),
        }),
        getMasterCatalogeMediaByID: builder.query({
          query: (data) => ({
            url: '',
            method: 'POST',
            data: {
              query: `query executeGetMediaByProductId ($input: Input_farm_nurture_product_service_proto_GetMediaByProductIdRequest) {
              executeGetMediaByProductId (input: $input) {
                  status {
                      status
                      errorMessages
                      internalErrorCode
                  }
                  count
                  attribs {
                      key
                      value
                  }
                  records {
                      id
                      catalogId
                      type
                      mediaFormat
                      status
                      position
                      mediaPath
                      createdBy
                      createdDate
                      modifiedBy
                      modifiedDate
                  }
              }
          }`,
              variables: { input: data },
            },
            headers: createGraphqlHeader(),
          }),
          providesTags: ['imageList'],
        }),
      }),
    });
export const {
  useGetMasterCatalogueListQuery,
  useGetMasterCatalogueProductByIdQuery,
  useGetMasterCatalogeMediaByIDQuery,
} = MasterCatalogueGraphQlService;
